import CommissionTiers from "../components/CommissionTiers";

export default function CommissionTiersPage() {
  return <CommissionTiers />;
}
